export interface BatchTrcAcceptMarcRegisterRequest {
  startNumFrom: string
  startNumTo: string
  vendorType: string
  traderType: string
  donorType: string
  acceptDate: string
  acceptType: string
  budgetYear: string
  budgetBranch: string
  budgetDepartment: string
  expenseCode: string
  equipType: string
  priceType: string
  isCalcPrice: boolean
  collectionStatus: string
  branch: string
  shelfType: string
  collectionType: string
  department: string
  handlingType: string
  storeType: string
  appendixCode: string
  isCheckDigit: boolean
  trcFile: string
  memo: string
  batchType: string
}

export function BatchTrcAcceptMarcRegisterRequestToJSON(
  value: BatchTrcAcceptMarcRegisterRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    vendor_type: value.vendorType,
    trader_type: value.traderType,
    donor_type: value.donorType,
    accept_date: value.acceptDate,
    accept_type: value.acceptType,
    budget_year: value.budgetYear,
    budget_branch: value.budgetBranch,
    budget_department: value.budgetDepartment,
    expense_code: value.expenseCode,
    equip_type: value.equipType,
    price_type: value.priceType,
    is_calc_price: value.isCalcPrice,
    collection_status: value.collectionStatus,
    branch: value.branch,
    shelf_type: value.shelfType,
    collection_type: value.collectionType,
    department: value.department,
    handling_type: value.handlingType,
    store_type: value.storeType,
    appendix_code: value.appendixCode,
    is_check_digit: value.isCheckDigit,
    trc_file: value.trcFile,
    memo: value.memo,
    batch_type: value.batchType
  }
}
